export default "__VITE_ASSET__7c86b6d0__"